var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.btnLoading,
            expression: "btnLoading"
          }
        ],
        staticClass: "login_info"
      },
      [
        _c("div", { staticClass: "form_item" }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("m.phone")))]),
          _vm._v(" "),
          _c("div", { staticClass: "form_inputbox" }, [
            _c(
              "div",
              {
                staticClass: "seledArea",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.showCountryFun.apply(null, arguments)
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "flag_icon",
                  attrs: { src: _vm.selCountry.logo }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "fc-pad-lr-min" }, [
                  _vm._v("+" + _vm._s(_vm.selCountry.countryNum))
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "select_icon",
                  attrs: {
                    src:
                      _vm.showCountry && _vm.$store.state.isShowSelArea
                        ? require("../../assets/img/icon_up.png")
                        : require("../../assets/img/icon_down.png")
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.mobile,
                  expression: "mobile",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "login_input",
              attrs: {
                type: "text",
                oninput: "value=value.replace(/\\D/g,'')",
                minlength: "6",
                placeholder: _vm.$t("m.user_enter_bind_phone"),
                autocomplete: "off"
              },
              domProps: { value: _vm.mobile },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.mobile = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _vm.showCountry && _vm.$store.state.isShowSelArea
              ? _c(
                  "div",
                  { staticClass: "selarea_box" },
                  [
                    _c("sel-area", {
                      on: { countryOption: _vm.countryOptionFun }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form_item" }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("m.passwd")))]),
          _vm._v(" "),
          _c("div", { staticClass: "form_inputbox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.passwd,
                  expression: "passwd",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "login_input smscode_input",
              attrs: {
                type: "password",
                maxlength: "20",
                minlength: "6",
                placeholder: _vm.$t("m.passwd_placeholder"),
                autocomplete: "off"
              },
              domProps: { value: _vm.passwd },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.passwd = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form_item" }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("m.agency_head_ID")))]),
          _vm._v(" "),
          _c("div", { staticClass: "form_inputbox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.userId,
                  expression: "userId",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "login_input smscode_input",
              attrs: {
                type: "text",
                oninput: "value=value.replace(/\\D/g,'')",
                maxlength: "10",
                placeholder: _vm.$t("m.bc_user_id_tip")
              },
              domProps: { value: _vm.userId },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.userId = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form_item" }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("m.vericode")))]),
          _vm._v(" "),
          _c("div", { staticClass: "form_inputbox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.picCode,
                  expression: "picCode",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "login_input smscode_input",
              attrs: {
                type: "text",
                maxlength: "6",
                placeholder: _vm.$t("m.input_vericode")
              },
              domProps: { value: _vm.picCode },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.picCode = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.picLoading,
                    expression: "picLoading"
                  }
                ],
                staticClass: "code-pic-box",
                on: { click: _vm.refreshPicCode }
              },
              [
                _c(
                  "el-image",
                  { staticClass: "code-pic", attrs: { src: _vm.captcha } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "image-slot",
                        attrs: { slot: "error" },
                        slot: "error"
                      },
                      [_c("i", { staticClass: "el-icon-picture-outline" })]
                    )
                  ]
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "fc-flex-center" }, [
          _c(
            "div",
            { staticClass: "login_btn", on: { click: _vm.userRegister } },
            [_vm._v(_vm._s(_vm.$t("m.reg")))]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bcf6457", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bcf6457","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/regTab.vue
// module id = null
// module chunks = 